import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/AddUnit.css";

const AddBed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editingBed = location.state?.bed || null;
  const [rooms, setRooms] = useState([]);
  const [roomId, setRoomId] = useState(editingBed ? editingBed.room_no_id || editingBed.room_id || editingBed.room_no : "");
  const [bedNo, setBedNo] = useState(editingBed ? editingBed.bed_no : "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const API_URL = process.env.REACT_APP_API_URL || "";

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await fetch(`${API_URL}room-list.php`);
        const data = await response.json();
        if (data.status === "success" && Array.isArray(data.data)) {
          setRooms(data.data);
        } else {
          showToast("Could not fetch rooms", "error");
        }
      } catch (error) {
        showToast("Network error while fetching rooms", "error");
      }
    };
    fetchRooms();
  }, [API_URL]);

  useEffect(() => {
    if (editingBed) {
      setRoomId(editingBed.room_no_id || editingBed.room_id || editingBed.room_no);
      setBedNo(editingBed.bed_no);
    }
  }, [editingBed]);

  useEffect(() => {
    if (!editingBed) {
      setRoomId("");
      setBedNo("");
    }
    // Only run when location changes
    // eslint-disable-next-line
  }, [location.key]);

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "" });
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!roomId) {
      showToast("Please select a room", "error");
      return;
    }
    if (!bedNo.trim()) {
      showToast("Please enter a bed number", "error");
      return;
    }
    setIsSubmitting(true);
    try {
      let response, data;
      if (editingBed) {
        response = await fetch(`${API_URL}bed-no-edit.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: editingBed.id,
            room_no_id: Number(roomId),
            bed_no: bedNo,
          }),
        });
      } else {
        response = await fetch(`${API_URL}bed-no-add.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            room_no_id: Number(roomId),
            bed_no: bedNo,
          }),
        });
      }
      data = await response.json();
      if (data.status === "success") {
        showToast(editingBed ? "Bed updated successfully!" : "Bed added successfully!", "success");
        setTimeout(() => {
          navigate("/bed-list");
        }, 1500);
      } else {
        showToast(data.message || (editingBed ? "Failed to update bed" : "Failed to add bed"), "error");
      }
    } catch (error) {
      showToast(`Network error: ${error.message}`, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-category-content">
      <div className="page-header" style={{ display: "block" }}>
        <h1>{editingBed ? "Edit Bed" : "Add New Bed"}</h1>
        <p>{editingBed ? "Edit bed details" : "Add a new bed to an existing room"}</p>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-unit-form">
          <div className="form-group">
            <label htmlFor="roomId">Room Number</label>
            <select
              id="roomId"
              name="roomId"
              value={roomId}
              onChange={(e) => setRoomId(e.target.value)}
              disabled={isSubmitting || rooms.length === 0}
              required
            >
              <option value="">Select a Room</option>
              {rooms.map((room) => (
                <option key={room.id} value={room.id}>
                  {room.room_no}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="bedNo">Bed Number</label>
            <input
              type="text"
              id="bedNo"
              name="bedNo"
              value={bedNo}
              onChange={(e) => setBedNo(e.target.value)}
              placeholder="e.g., B-6, Bed 1"
              required
              disabled={isSubmitting}
            />
          </div>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? (editingBed ? "Updating Bed..." : "Adding Bed...") : (editingBed ? "Update Bed" : "Add Bed")}
          </button>
        </form>
      </div>
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button
              className="toast-close"
              onClick={() => setToast({ show: false, message: "", type: "" })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddBed;
